module.exports = __webpack_public_path__ + "img/collaborate_17.62ccfef5.jpg";